import { render, staticRenderFns } from "./FilterSidebar.vue?vue&type=template&id=088c7006&scoped=true"
import script from "./FilterSidebar.vue?vue&type=script&lang=js"
export * from "./FilterSidebar.vue?vue&type=script&lang=js"
import style0 from "./FilterSidebar.vue?vue&type=style&index=0&id=088c7006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088c7006",
  null
  
)

export default component.exports